import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bigid:'',
    clistid:'',
    tlistid:''
  },
  getters: {
  },
  mutations: {
    setBigid(state,data){
      state.bigid = data
    },
    setClistid(state,data){
      state.clistid = data
    },
    setTlistid(state,data){
      state.tlistid = data
    },
  },
  actions: {
  },
  modules: {
  }
})
